export function scrollToTopOfSearchResults(): void {
  const searchResultsElement = document.getElementsByClassName('SearchResults__Main')[0];
  if (searchResultsElement) {
    searchResultsElement.scrollIntoView({ behavior: 'auto', block: 'start' });
  }
}
